import { ChartLegend } from './Legend';
export default ChartLegend;